<template>
  <div class="aspect-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2>Aspect</h2>
        </div>
        <div class="col-4">
          <vueSelect
              :searchable="false"
              :options="first_natal"
              v-model="aspectValues.first_natal"
              :disabled="editMode"
              placeholder="First Natal"
              required="required"
          />
        </div>
        <div class="col-4">
          <vueSelect
              :searchable="false"
              :options="aspects"
              :disabled="editMode"
              v-model="aspectValues.aspect"
              placeholder="Aspect"
              required="required"
          />
        </div>
        <div class="col-4">
          <vueSelect
              :searchable="false"
              :options="last_natal"
              :disabled="editMode"
              v-model="aspectValues.last_natal"
              placeholder="Last Natal"
              required="required"
          />
        </div>
        <div class="col-12">
          <h2>Interpretation</h2>
        </div>
        <div class="col-12">
					<textarea
              v-model="aspectValues.data"
          />
        </div>
        <div class="col-12" v-if="errorMessage.length">
          <div class="errors-wrapper">
            <div v-for="(singleError, index) in errorMessage" :key="index">{{ singleError }}</div>
          </div>
        </div>
        <div class="col-6">
          <button
              v-if="editMode"
              @click.prevent="deleteButtonHandler"
          >Delete
          </button>
        </div>
        <div class="col-6 buttons-wrapper align-end">
          <button
              @click.prevent="handleRedirect"
          >Cancel
          </button>
          <button
              @click.prevent="handleAspectSubmit"
          >Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSelect from 'vue-select'

import SolFileAPIInstance from '@/api'

export default {
  props: {
    editMode: {
      required: false,
      type: Boolean
    },
    aspectData: {
      required: false,
      type: Object
    }
  },
  name: "AspectTableSingleComponents",
  components: {
    vueSelect
  },
  data() {
    return {
      first_natal: [],
      last_natal: [],
      aspects: [],
      aspectValues: {
        first_natal: '',
        aspect: '',
        last_natal: '',
        data: ''
      },
      errorMessage: []
    }
  },

  mounted() {
    this.fetchFilters()
    if (this.editMode) {
      this.aspectValues = this.aspectData
    }
  },

  methods: {
    async fetchFilters() {
      const filters = await SolFileAPIInstance.getAspectFilters()
      const {
        aspects,
        first_natal,
        last_natal
      } = filters.data
      this.aspects = aspects
      this.first_natal = first_natal
      this.last_natal = last_natal
    },

    handleRedirect() {
      this.$router.push({path: '/aspect'})
    },

    validateAspectValues() {
      this.errorMessage = []
      const {
        first_natal,
        aspect,
        last_natal,
        data
      } = this.aspectValues

      if (!first_natal)
        this.errorMessage.push('Please select First Natal Planet')
      if (!aspect)
        this.errorMessage.push('Please select Aspect')
      if (!last_natal)
        this.errorMessage.push('Please select Last Natal Planet')
      if (!data)
        this.errorMessage.push('Please enter interpretation')
      return !this.errorMessage.length;
    },

    async deleteButtonHandler() {
      await SolFileAPIInstance.deleteAspectInterpretationById(this.$route.params.id)
    },

    async handleAspectSubmit() {
      if (this.validateAspectValues()) {
        this.editMode
            ? await SolFileAPIInstance.updateAspectInterpretation({...this.aspectValues, id: this.$route.params.id})
            : await SolFileAPIInstance.addNewAspectInterpretation(this.aspectValues)
        //
      }
    }
  }
}
</script>

<style scoped lang="scss">

.aspect-wrapper {
  padding: 25px;

  textarea {
    min-height: 300px;
  }
}

</style>